import Typography from 'material-ui/Typography/Typography';

export default Typography;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Typography/index.ts